import React from "react";
import "react-responsive-modal/styles.css";
import "./LoadingModal.scss";

export default class LoadingModal extends React.Component {
  render() {
    return (
      this.props.showLoadingModal && (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      )
    );
  }
}
